var _rect, _rect2, _rect3, _rect4;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgAheadBehind(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 25,
    height: 25,
    viewBox: "0 0 25 25",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 13,
    height: 13,
    fill: "#0C9CB1"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 15,
    y: 4,
    width: 10,
    height: 9,
    fill: "#C5DCE3"
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    x: 3,
    y: 15,
    width: 10,
    height: 10,
    fill: "#C5DCE3"
  })), _rect4 || (_rect4 = /*#__PURE__*/React.createElement("rect", {
    x: 15,
    y: 15,
    width: 10,
    height: 10,
    fill: "#C5DCE3"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAheadBehind);
export default __webpack_public_path__ + "static/media/aheadBehind.c4f5902e6bbe193e7616e49c77116913.svg";
export { ForwardRef as ReactComponent };